import styled from '@emotion/styled';
import { fontSize, ContentWrapper } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

export const Container = styled.section`
  background-color: #f7f7f8;
  padding: 72px 0;

  @media only screen and ${breakpoint.lg} {
    padding: 32px 0;
  }
`;

export const Wrapper = styled(ContentWrapper)`
  h2 {
    margin-bottom: 72px;
    font-weight: 400;
  }

  @media only screen and ${breakpoint.lg} {
    h2 {
      margin-bottom: 20px;
      font-size: ${fontSize(24)};
    }
  }
`;

export const VerticalRule = styled.div`
  position: absolute;
  background-color: black;
  height: 100%;
  width: 8px;

  @media only screen and ${breakpoint.lg} {
    width: 3px;
    height: calc(100% - 30px);
  }
`;

export const StyledSchedule = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;

  @media only screen and ${breakpoint.lg} {
    display: block;
  }
`;

export const ScheduleWrapper = styled.div`
  width: 650px;
  display: flex;
  flex-direction: column;

  & div:nth-of-type(2n) {
    align-self: flex-end;
    text-align: left;
    padding-right: unset;
    padding-left: 14px;

    p {
      padding-left: 14px;
      margin-left: unset;
    }

    span {
      left: 0px;
    }
  }

  & div:last-of-type {
    margin-bottom: 0px;
  }

  @media only screen and ${breakpoint.lg} {
    width: 100%;

    & div:nth-of-type(2n) {
      align-self: unset;
      text-align: left;
    }

    .mobileView {
      padding-left: 30px !important;
      &.mobileView.dot {
        span {
          left: 15px !important;
        }
      }
    }

    .marginMobile {
      margin-bottom: 0;
    }

    h6 {
      padding-left: 15px;
  }
`;

export const Month = styled.div`
  margin-bottom: 16px;
  width: 50%;
  text-align: right;
  padding-right: 14px;
  line-height: 1.71;
  letter-spacing: -0.21px;
  color: #00405b;
  font-size: ${fontSize(14)};

  h5,
  h6 {
    color: #e6007e;
    text-transform: uppercase;
    margin-bottom: 15px;
  }

  @media only screen and ${breakpoint.lg} {
    width: 100%;
    text-align: left;
    padding-left: 14px;

    p {
      padding-left: 14px;
    }

    span {
      left: 0;
    }
  }
`;

export const Dot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #e6007e;
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -12px;
`;

export const Deadline = styled.p`
  margin-bottom: 4px;
  width: fit-content;
  margin-left: auto;
  position: relative;
  color: #00202d;
  font-size: ${fontSize(16)};

  @media only screen and ${breakpoint.lg} {
    margin-left: 0;
  }
`;
export const Topic = styled.p`
  margin-bottom: 15px;
  position: relative;
  width: fit-content;
  margin-left: auto;
  color: #00202d;
  font-size: ${fontSize(16)};

  @media only screen and ${breakpoint.lg} {
    margin-left: 0;
    white-space: nowrap;
  }
`;

export const TopSquare = styled.div`
  position: absolute;
  width: calc(50% - 150px);
  height: 195px;
  background-color: inherit;
  border: 4px solid #272727;
  border-right: none;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  left: 152px;
  top: 413px;

  @media only screen and ${breakpoint.lg} {
    display: block;
    border: 3px solid #009fe3;
    border-top: none;
    border-bottom: none;
    border-right: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    top: 460px;
    left: 16px;
    height: 225px;
  }

  @media only screen and (max-width: 413px) {
    height: 367px;
  }
`;

export const CompanyTile = styled.div`
  width: 300px;
  height: 100px;
  background-color: #fff;
  box-shadow: ${({ theme }) => theme.shadow.medium};
  position: absolute;
  top: 50%;
  left: ${(props) => props.type === 'left' && -150}px;
  right: ${(props) => props.type === 'right' && -150}px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h4 {
    color: #009fe3;
  }

  p {
    font-size: ${fontSize(14)};
    margin-top: 10px;
  }

  @media only screen and ${breakpoint.xl} {
    width: 200px;
  }

  @media only screen and ${breakpoint.lg} {
    display: none;
  }
`;

export const BottomSquare = styled.div`
  position: absolute;
  width: calc(50% - 150px);
  height: 165px;
  background-color: inherit;
  border: 4px solid #272727;
  border-left: none;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  right: 152px;
  bottom: 130px;

  @media only screen and ${breakpoint.lg} {
    display: block;
    border: 3px solid #009fe3;
    border-top: none;
    border-bottom: none;
    border-right: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    bottom: 113px;

    left: 16px;
    height: 160px;
  }

  @media only screen and (max-width: 349px) {
    bottom: 148px;
  }
`;

export const MobileTile = styled.div`
  display: none;
  margin: 20px 0 !important;

  h4 {
    color: #009fe3;
  }

  @media only screen and ${breakpoint.lg} {
    display: block;
  }
`;
